import { availableActions } from "./availableActions";

const actionIconMap = availableActions.reduce((acc, action) => {
  acc.set(action.value, action.icon);
  return acc;
}, new Map<string, string | undefined>());

export const getActionIcon = (actionType: string, defaultIcon = "user") =>
  actionIconMap.get(actionType) || defaultIcon;
